export default __webpack_public_path__ + "static/media/ctabuttonSvg.987c8921.svg";